export default __webpack_public_path__ + "static/media/169b664b6867fba7.064f069adae4a7113430eea78f0126b0.svg";